export default __webpack_public_path__ + "static/media/bngo_animres.c6a09648.mp3";